module.exports = __webpack_public_path__ + "img/system1-details.85ff84fb.png";